<template>
    <el-button type="primary" :icon="Search" @click="submit()">新增</el-button>
    <div style="margin: 10px 0;">
        <el-text class="mx-1" size="large"><span style="color: red;">*</span>资源标题</el-text>

        <el-input v-model="title" autocomplete="off" placeholder="标题"></el-input>
    </div>
    <div style="margin: 10px 0;">
        <el-text class="mx-1" size="large"><span style="color: red;">*</span>资源目录</el-text>
        <el-select v-model="CatalogId" placeholder="请选择资源的目录">
            <el-option v-for="item in tableData" :label="item.title" :value="item.id"> </el-option>
        </el-select>
    </div>
    <div style="margin: 10px 0;">
        <el-text class="mx-1" size="large">资源文件</el-text>
        <el-upload v-model:file-list="fileList" action="ok" :auto-upload="false" list-type="text"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" multiple>
            <template #trigger>
                <el-button>选择资源文件</el-button>
            </template>
        </el-upload>
        <div style="margin: 5px 10px;font-size: 14px;color:#8a8a8a">文件格式仅支持png、jpg、jpeg、doc、docx、pdf、zip和rar</div>
    </div>
    <div style="margin: 10px 0;">
        <el-text class="mx-1" size="large">文件存放路径</el-text>
        <el-input v-model="saveUrl" autocomplete="off" placeholder="请输入存放资源文件的位置"></el-input>
        <div style="margin: 5px 10px;font-size: 14px;color:#8a8a8a">默认路径可以不填，格式为'/resource',以/开头，结尾不包含/</div>
    </div>
    <el-dialog v-model="dialogVisible">
        <img w-full :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
    <div style="margin: 10px 0;">
        <el-text class="mx-1" size="large"><span style="color: red;">*</span>正文</el-text>
        <div style="border: 1px solid #ccc">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" />
            <Editor style="height: 500px" v-model="value" :defaultConfig="editorConfig" @onCreated="handleCreated" />
        </div>

        <div style="margin: 5px 10px;font-size: 14px;color:red">注意：富文本目前不支持带文件的内容，只支持纯文本</div>
    </div>

    <el-input v-model="remarks" autocomplete="off" placeholder="备注"></el-input>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { ElTree, ElButton, ElMessage } from 'element-plus';
const axios = require("axios");
import { inject } from 'vue'

export default {
    components: {
        Editor,
        Toolbar,
    },
    data() {
        return {
            editorRef: null, // 编辑器实例
            value: '<p>Hello World!</p>', // 编辑器内容
            editorConfig: { placeholder: '请输入内容...' }, // 编辑器配置
            title: '',
            remarks: '',
            saveUrl: '/resource',
            tableData: [],
            serverUrl: inject('serverUrl'),
            CatalogId: 1,
            fileList: [],
            fileListOut: [],
            dialogImageUrl: '',
            dialogVisible: false,
        };
    },
    mounted() {
        this.getCatalogList();
    },
    methods: {
        handleCreated(editor) {
            this.editorRef = editor; // 保存编辑器实例
        },
        async submit() {
            console.log(this.value);
            //建议文件上传

            //等待文件上传返回文件id
            var failFlag = await this.upaction(); // 等待上传图片完成

            if (failFlag == 1) {
                ElMessage({
                    type: 'error',
                    message: '部分文件上传出错，已自动删除，请重新提交！',
                })
                return;
            }
            //输出的文件列表fileListOut
            //提交表单
            console.log('保存返回的图片id数组',this.fileListOut);
            
            const res = await axios.post(
                this.serverUrl + "/api/resource/save", // 请求后端的 URL
                //{ file: newbasesrc },
                {
                    'id': '',
                    'title': this.title,
                    'content': this.value,
                    'remarks': this.remarks,
                    'catalogId': this.CatalogId,
                    'fileIds': this.fileListOut
                },
                null
            );
            console.log(res);
            if (res.data.code == 'fail') {

                ElMessage({
                    type: 'error',
                    message: '错误' + res.data.msg,
                })

                return '';
            }

            ElMessage({
                message: "新增成功！",
                grouping: true,
                type: "success",
            });

        },
        // 上传图片
        async upaction() {
            var that = this;
            //拷贝数组
            const filesToProcess = [...this.fileList];
            var failFlag = 0;
            for (let i = 0; i < filesToProcess.length; i++) {
                var srcId = await this.uploadFile(filesToProcess[i]);
                if (srcId == '') {
                    // 删除当前项
                    this.fileList.splice(i, 1);
                    failFlag = 1;
                } else {
                    this.fileListOut.push(srcId);
                }
            }

            return failFlag;
        },
        async uploadFile(file) {
            /*
            console.log("uploadFile中，未编码url为", file.url);
            const newbasesrc = await this.getdata(file);
            console.log("编码url后", newbasesrc);
      */
            const formData = new FormData();
            //const fileBlob = this.base64ToBlob(newbasesrc.split(",")[1], "image/png");

            // ✅ 正确：使用 fileBlob，并指定文件名（可选）
            formData.append("file", file.raw);
            formData.append("fileName", file.name);
            formData.append("fileExtension", file.name.split('.')[1]);
            formData.append("fileType", file.raw.type);
            formData.append("fileSize", file.raw.size);
            formData.append("saveUrl", this.saveUrl);
            try {
                const res = await axios.post(
                    this.serverUrl + "/api/resource/upload/file", // 请求后端的 URL
                    //{ file: newbasesrc },
                    formData,
                    null
                );
                console.log(res);
                if (res.data.code == 'fail') {

                    ElMessage({
                        type: 'error',
                        message: '错误' + res.data.msg,
                    })

                    return '';
                }

                ElMessage({
                    message: file.name + "上传成功！",
                    grouping: true,
                    type: "success",
                });

                return res.data.obj.fileId;
                //console.log(res);
            } catch (error) {
                console.error("代理请求失败:", error);
            }
            return "";
        },

        async getCatalogList() {
            const res = await axios.post(
                this.serverUrl + "/api/catalog/list/all", // 请求后端的 URL
                {},
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            console.log('目录列表', res);
            if (res.data.code == "success") {
                ElMessage({
                    type: 'success',
                    message: '目录列表获取成功',
                })

                this.tableData = res.data.obj
            } else {
                ElMessage({
                    type: 'error',
                    message: '目录列表获取失败',
                })
            }
        },
        handlePictureCardPreview(uploadFile) {
            //console.log(uploadFile);
            this.dialogImageUrl = uploadFile.url;
            this.dialogVisible = true;
        },

        handleRemove(file, fileList) {
            //console.log(file);
            //console.log(fileList);
        },
    },
    beforeUnmount() {
        // 组件销毁时销毁编辑器
        if (this.editorRef == null) return;
        this.editorRef.destroy();
        this.editorRef = null;
    },
};
</script>